import { ReactNode } from 'react';

import { LoadingPage } from 'components/Loading/LoadingPage';

import { Header } from './components/Header/Header';

const SIDEBAR_POSITION_TOP = 7;

export const OrderFormPageLayout = ({
  children,
  headerContent,
  isLoading,
  sidebar,
}: {
  children: ReactNode;
  headerContent?: ReactNode;
  isLoading?: boolean;
  sidebar?: ReactNode;
}) => {
  if (isLoading) {
    return (
      <div className="mx-auto h-screen">
        <LoadingPage />
      </div>
    );
  }
  return (
    <>
      <Header rightContent={headerContent} />
      {sidebar && (
        <aside
          className={`fixed left-8 w-64 overflow-y-auto pb-4`}
          style={{ height: `calc(100vh - ${SIDEBAR_POSITION_TOP}rem)`, top: `${SIDEBAR_POSITION_TOP}rem` }}
        >
          {sidebar}
        </aside>
      )}
      <Main hasSidebar={!!sidebar}>{children}</Main>
    </>
  );
};

const Main = ({ children, hasSidebar }: { children: ReactNode; hasSidebar: boolean }) => {
  return (
    <main
      className={`min-h-screen max-w-[1440px] p-8 ${hasSidebar ? 'ml-80' : 'mx-auto'}`}
      style={{ minHeight: 'calc(100vh - var(--order-form-header-height, 0px))' }}
    >
      {children}
    </main>
  );
};
